export const CHANGE_AUX_STORE_ACTION = 'AUX_STORE/CHANGE_STORE';

export const changeAuxStoreObject = newObject => ({
  type: CHANGE_AUX_STORE_ACTION,
  newObject,
});
